module.exports = __webpack_public_path__ + "media/images/diy/uplighting-07deb746e207537a40c8e18612c4723b.jpg";